// Centralized branding constants (TypeScript)
export const BRAND_NAME = 'Rubix';
export const BRAND_SHORT = 'Rubix';
export const TAGLINE = 'AI-powered document intelligence';
